import React, { useEffect, useState } from 'react'
import ApiService from '../../functions/apiService';
import { useSelector } from 'react-redux';
import SectionHeader from './SectionHeader';
import { Card, CardContent, Chip, Grid, Typography, Box, Divider } from '@mui/material';

const getStatusText = (statusText) => {
  const value = statusText || "";
  const parenIndex = value.indexOf("(");
  return parenIndex === -1 ? value : value.substring(0, parenIndex).trim();
};

const getEmployeeName = (statusText) => {
  const value = statusText || "";
  const match = value.match(/\(([^)]*)\)/);
  return match ? match[1].trim() : "";
};

const DetailRow = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, py: 0.25 }}>
    <Typography sx={{ fontFamily: 'karla, sans-serif', fontSize: 12, color: '#888' }}>
      {label}
    </Typography>
    <Typography
      sx={{
        fontFamily: 'karla, sans-serif',
        fontSize: 12,
        fontWeight: 600,
        color: '#222',
        textAlign: 'right',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '60%',
      }}
      title={value || ''}
    >
      {value || '-'}
    </Typography>
  </Box>
);

export default function ManagementDetail() {
  const [row, setRow] = useState([]);
  let data = useSelector((state) => state.dashboardReducer.Data)

  useEffect(() => {
    ApiService.get('/todayDetails', { date: data.date }, 'todayDetails').then(({ data }) => {
      setRow(data.data)
    })
  }, [data])

  return (
    <div>
      {row && row.length > 0 &&
        <>
          <div className='m-3 pb-2'>
            <SectionHeader title="Details" count={row.length} />
            <Grid container spacing={2}>
              {row.map((item, index) => {
                const statusText = getStatusText(item.StatusText);
                const employeeName = getEmployeeName(item.StatusText);
                const isFilled = statusText === 'Filled';

                return (
                  <Grid item xs={12} sm={6} md={4} key={item.id || index}>
                    <Card
                      elevation={0}
                      sx={{
                        height: '100%',
                        borderRadius: '14px',
                        border: '1px solid #ececec',
                        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                        '&:hover': {
                          boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
                          transform: 'translateY(-2px)',
                        },
                      }}
                    >
                      <Box
                        sx={{
                          height: 4,
                          width: '100%',
                          backgroundColor: '#BF1D2D',
                          borderTopLeftRadius: '14px',
                          borderTopRightRadius: '14px',
                        }}
                      />
                      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                          <Typography
                            sx={{
                              fontFamily: 'karla, sans-serif',
                              fontWeight: 700,
                              fontSize: 14,
                              color: '#222',
                            }}
                          >
                            {item.DetailType || '-'}
                          </Typography>
                          <Chip
                            label={statusText || '-'}
                            size="small"
                            sx={{
                              height: 20,
                              '& .MuiChip-label': { px: 1, fontSize: 11 },
                              backgroundColor: isFilled
                                ? 'rgba(1, 120, 79, 0.1)'
                                : 'rgba(255, 165, 0, 0.16)',
                              color: isFilled
                                ? 'rgba(1, 120, 79, 1)'
                                : '#FF8C00',
                              border: isFilled
                                ? '1px solid rgba(1, 120, 79, 1)'
                                : '1px solid rgba(255, 165, 0, 0.28)',
                              fontFamily: 'karla, sans-serif',
                              fontWeight: 600,
                            }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            fontFamily: 'karla, sans-serif',
                            fontSize: 12,
                            color: '#BF1D2D',
                            fontWeight: 600,
                            mt: 0.25,
                          }}
                        >
                          {item.ShiftName || '-'}
                        </Typography>

                        <Divider sx={{ my: 0.75 }} />

                        <DetailRow label="Employee Name" value={employeeName} />
                        <DetailRow label="Assignment" value={item.AssignmentText} />
                        <DetailRow label="Rank" value={item.Rank} />
                        <DetailRow label="EMT" value={item.EMT} />

                        {item.DetailText &&
                          <Typography
                            sx={{
                              fontFamily: 'karla, sans-serif',
                              fontSize: 12,
                              color: '#666',
                              mt: 0.75,
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                            }}
                            title={item.DetailText}
                          >
                            {item.DetailText}
                          </Typography>
                        }
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </>
      }
    </div>
  )
}
